import React, { useEffect, useState } from "react";

const SocialLinks = () => {
  

  return (
    <div>
        <a href="https://github.com/VikramVenkatapathi" className="google-plus">
            <i className="bx bxl-github"></i>
        </a>
        <a href="https://www.linkedin.com/in/vikram-venkatapathi/" className="linkedin">
            <i className="bx bxl-linkedin"></i>
        </a>
        <a href="mailto:vikramvenkatapathi@gmail.com">
            <i className="bx bx-envelope"></i>
        </a>
        <a href="https://calendly.com/vikramvenkatapathi/virtual-vibes" target="_blank" title="Book a meeting with me">
            <i class="bx bx-calendar-plus"></i>
        </a>
        <a href="https://medium.com/@vikramvenkatapathi" target="_blank" title="My Blog on Medium.com">
            <i className="bx bxl-medium"></i>
        </a>
        <a href="https://www.credly.com/users/vikram-venkatapathi" target="_blank" title="My Credly profile">
            <i class="bx bx-badge-check"></i>
        </a>
    </div>
  );
};

export default SocialLinks;
